// GenderChart.js
import React from 'react';
import { Doughnut } from 'react-chartjs-2';

const GenderChart = React.memo(
  ({ maleCount, femaleCount }) => {
    // Move gradient creation to useMemo
    const gradientRef = React.useRef(null);

    const data = React.useMemo(
      () => ({
        labels: ['Мужчины', 'Женщины'],
        datasets: [
          {
            label: 'Соотношение мужчин и женщин',
            data: [maleCount, femaleCount],
            backgroundColor: context => {
              const chart = context.chart;
              const { ctx, chartArea } = chart;

              if (!chartArea) {
                return null;
              }

              // Only create new gradient if it doesn't exist
              if (!gradientRef.current) {
                const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
                gradient.addColorStop(0, '#9378ff');
                gradient.addColorStop(1, '#5c3cdb');
                gradientRef.current = gradient;
              }

              return [gradientRef.current, '#0D0D15'];
            },
            hoverBackgroundColor: ['#5c3cdb', '#0D0D15'],
            borderWidth: 0
          }
        ]
      }),
      [maleCount, femaleCount]
    ); // Only recreate data when counts change

    const options = React.useMemo(
      () => ({
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 1,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              fontColor: '#FFFFFF',
              usePointStyle: true,
              pointStyle: 'circle',
              padding: 20,
              generateLabels: chart => {
                const total = maleCount + femaleCount;
                return [
                  {
                    text: `Мужчины: ${((maleCount / total) * 100).toFixed(1)}%`,
                    fillStyle: '#9378ff',
                    fontColor: '#FFFFFF',
                    color: '#FFFFFF',
                    index: 0
                  },
                  {
                    text: `Женщины: ${((femaleCount / total) * 100).toFixed(1)}%`,
                    fillStyle: '#0D0D15',
                    fontColor: '#FFFFFF',
                    color: '#FFFFFF',
                    index: 1
                  }
                ];
              }
            }
          },
          tooltip: {
            callbacks: {
              label: context => context.label || ''
            }
          }
        },
        layout: {
          padding: {
            top: 15
          }
        }
      }),
      [maleCount, femaleCount]
    ); // Only recreate options when counts change

    return <Doughnut data={data} options={options} />;
  },
  (prevProps, nextProps) => {
    // Custom comparison function for memo
    return prevProps.maleCount === nextProps.maleCount && prevProps.femaleCount === nextProps.femaleCount;
  }
);

export default GenderChart;
